import { axios } from '@/main';

export default class SummaryResource {
    async get (startDate, endDate, websiteId) {
        return await axios.get(process.env.VUE_APP_REST_API + `transactions-stats/date-period?from=${startDate}&to=${endDate}&website=${websiteId}`)
    }

    async getSummaryTransactions (startDate, endDate, websiteId) {
        return await axios.get(process.env.VUE_APP_REST_API + `transactions-stats/network?from=${startDate}&to=${endDate}&website=${websiteId}`)
    }
}
